import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { BrowserService } from './browser-service.interface';

export const DataAccessBrowserService = new InjectionToken<BrowserService>(
  'BrowserService',
);

export interface BrowserServiceUseClass extends ClassSansProvider {
  useClass: Type<BrowserService>;
}

export interface BrowserServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => BrowserService;
}

export type BrowserServiceProvider =
  | BrowserServiceUseFactory
  | BrowserServiceUseClass;

export function provideDataAccessBrowserService(
  config: BrowserServiceProvider,
) {
  return {
    provide: DataAccessBrowserService,
    ...config,
  };
}
